export default __webpack_public_path__ + "static/media/Google-removebg-preview.56221af9.png";